import { ContactDetailsSection } from "src/components/contact-details/contact-details-section";

export type LandingPageContactDetailsProps = {
  isVisible: boolean;
  showContactPreference: boolean;
  showError: boolean;
  showExplanation: boolean;
  setShowError: (showError: boolean) => void;
  showEditDetails: boolean;
  setShowEditDetails: (showEditDetails: boolean) => void;
  showSubmit: boolean;
};

const LandingContactDetails = ({
  isVisible,
  showContactPreference,
  showError,
  setShowError,
  showExplanation,
  setShowEditDetails,
  showEditDetails,
  showSubmit
}: LandingPageContactDetailsProps) => {

  if (!isVisible) {
    return null;
  }

  const toggleContactDetails = () => {
    setShowEditDetails(!showEditDetails);
    window.scrollTo({top:0, left: 0, behavior: "auto"});
  };

  return (
    <div
      className={`transition-opacity ease-in-out ${isVisible ? "opacity-100" : "opacity-0"}`}
      data-testid="landingContactDetails"
    >
      <ContactDetailsSection
        showContactPreference={showContactPreference}
        showSubmitButton={showSubmit}
        editShowError={showError}
        onCloseEditError={() => setShowError(false)}
        showContactExplainer={showExplanation}
        showEditDetails={showEditDetails}
        toggleContactDetails={toggleContactDetails}
      />
    </div>
  );
};

export default LandingContactDetails;
